module.exports = __webpack_public_path__ + "static/media/22-1.04a2b7bb.mp3";